import React, { useState, useEffect } from "react";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";
import Sidebar from "./AdminComp/Sidebar";
import BreadCrumb from "./AdminComp/BreadCrumb";
import { Edit, Trash2, Eye, Plus } from "react-feather"; 
import axios from "axios";
import { baseurl } from "../../component/Baseurl";
import AddAgent from "./AdminComp/AddAgent";
import Swal from "sweetalert2";

function AllDistributors() {
  const [distributors, setdistributors] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(5);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch distributors from API on component mount
  useEffect(() => {
    const getdistributors = async () => {
      try {
        const response = await axios.get(`${baseurl}getDistributors`);
        console.log("data", response);

        if (response.data.message === "distributor fetched successfully") {
          setdistributors(response.data.distributors);
        } else {
          setdistributors([]); // Set distributors to an empty array if no distributors are returned
        }
      } catch (error) {
        console.error("Error fetching distributors:", error.message);
        setdistributors([]); // Set distributors to an empty array in case of error
      } finally {
        setLoading(false); // Stop the loading spinner once the request is complete
      }
    };
    getdistributors();
  }, []);

  const filtereddistributors = distributors.filter(
    (distributor) =>
      distributor.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      distributor.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalRecords = filtereddistributors.length;
  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const startIndex = (currentPage - 1) * recordsPerPage;
  const paginateddistributors = filtereddistributors.slice(
    startIndex,
    startIndex + recordsPerPage
  );

  const handleView = (user) => {
    setSelectedUser(user);
    const modal = new window.bootstrap.Modal(document.getElementById("userDetailModal"));
    modal.show();
  };

  const handlePageChange = (page) => setCurrentPage(page);

  const handleRecordsPerPageChange = (e) => {
    setRecordsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page
  };


 

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to delete this distributor?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });
  
    if (!result.isConfirmed) return;
  
    try {
      const response = await axios.delete(`${baseurl}deleteDistributorById/${id}`);
  
      Swal.fire({
        title: 'Deleted!',
        text: 'Distributor deleted successfully.',
        icon: 'success',
        timer: 1000,
        showConfirmButton: false,
      }).then(() => {
        window.location.reload();
      });
      
  
      // Optional: update UI
      // setDistributors(prev => prev.filter(distributor => distributor.id !== id));
      
    } catch (error) {
      console.error("Delete error:", error);
  
      Swal.fire({
        title: 'Error!',
        text: error.response?.data?.message || "An error occurred while deleting.",
        icon: 'error',
      });
    }
  };
  




  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />
        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
            <BreadCrumb />
            <div className="container-fluid">
              <div className="crdmain mb-2">
                <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                  <h2 className="chart-title mb-0">State Head</h2>
                  <div className="ms-auto">
                    <AddAgent />
                  </div>
                </div>

                {/* Search and Records Per Page */}
                <div className="row g-1 mt-0 mb-0 justify-content-end">
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="input1"
                      placeholder="Search by name or email"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  <div className="col-md-1 text-end">
                    <select
                      className="input1"
                      value={recordsPerPage}
                      onChange={handleRecordsPerPageChange}
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="15">15</option>
                    </select>
                  </div>
                </div>

                {/* Table */}
                <div className="row g-2 mt-0 mb-0">
                  <div className="col-md-12 p-0">
                    <div className="table-responsive classic-table">
                      <table className="table table-striped table-hover">
                        <thead className="table-header text-start">
                          <tr className="text-start">
                            <th className="text-start">#</th>
                            <th className="text-start">Name</th>
                            <th className="text-start">Email</th>
                            <th className="text-start">Unique ID</th>
                            <th className="text-start">City/State</th>
                            <th className="text-start">Cost Per Pin</th>
                            <th className="text-start">Add Pins</th>
                            <th className="text-start">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan="7" className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            paginateddistributors.length > 0 ? (
                              paginateddistributors.map((distributor, index) => (
                                <tr key={distributor.id}>
                                  <td>{startIndex + index + 1}</td>
                                  <td>{distributor.name}</td>
                                  <td>{distributor.email}</td>
                                  <td>{distributor.distributor_unique_id}</td>
                                  <td>{`${distributor.city}, ${distributor.state}`}</td>
                                  <td>&#8377;{distributor.cost_per_pin || "0"}</td>

                                  <td>
                                  <Link to={`/add-pins/${distributor.id}`} className="btn3 btn-primary text-white" title="add Pin">
                                      <Edit size={15} />Add Pins
                                    </Link>
                                  </td>
                                  <td>

 



                                    <Link to={`/edit-distributor/${distributor.id}`} className="btn2 me-2" title="Edit">
                                      <Edit size={15} />
                                    </Link>
                                  
                                    <span 
  className="btn2" 
  title="Delete" 
  onClick={() => handleDelete(distributor.id)}
>
  <Trash2 size={15} />
</span>

                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="7" className="text-center">
                                  No records found.
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Pagination */}
                <div className="d-flex justify-content-end mt-3">
                  <nav>
                    <ul className="pagination">
                      {[...Array(totalPages)].map((_, index) => (
                        <li
                          className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                          key={index}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bootstrap Modal */}
      <div
        className="modal fade"
        id="userDetailModal"
        tabIndex="-1"
        aria-labelledby="userDetailModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="userDetailModalLabel">
                User Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {selectedUser ? (
                <table className="table table-bordered">
                  <tbody>
                    {Object.entries(selectedUser).map(([key, value]) => (
                      <tr key={key}>
                        <td>
                          <strong>{key.replace(/([A-Z])/g, " $1").toUpperCase()}:</strong>
                        </td>
                        <td>{value || "N/A"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div>Loading...</div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AllDistributors;
